import {DatePicker, Input, Select} from "antd";
import {Dayjs} from "dayjs";
import "./big-date-picker.css";

export interface BigDatePickerProps {
    value: Dayjs | null;
    setValue: (newVal: Dayjs | null) => void;
    placeholder?: string;
    selectClassName?: string;
    optionClassName?: string;
    disabled?: boolean;
}

const BigDatePicker = ({ value, setValue, placeholder, selectClassName, optionClassName, disabled }: BigDatePickerProps) => {
    return (
        <DatePicker disabled={disabled} placeholder={placeholder} onChange={(newValue) => setValue(newValue)} className={`date-picker-select ${selectClassName}`} value={value} />
    );
}

export default BigDatePicker;